import React from "react";

interface iSignupProps {}

const Signup: React.FC<iSignupProps> = () => {
  return <></>;
};

export default Signup;
